import ZH_TRANSLATION from '@/i18n/locales/zh/translation'

class CommonUtils {
  getImagePath(path: string) {
    return new URL(`/src/assets/${path}`, import.meta.url).href
  }

  /**
   * 将对象的键从下划线命名转换为驼峰命名。
   * 如果对象的值是嵌套的对象，也会递归转换。
   *
   * @param obj - 输入的对象
   * @returns 返回转换后的对象
   */
  camelizeObj(obj: Record<string, any>): Record<string, any> {
    if (Array.isArray(obj)) {
      // 如果是数组，递归转换数组中的每一项
      return obj.map((item) => this.camelizeObj(item))
    } else if (obj !== null && typeof obj === 'object') {
      // 如果是对象，转换对象的每个键
      const newObj: Record<string, any> = {}
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          // 转换当前键，并递归转换值
          const newKey = this.underLineToCamelize(key)
          newObj[newKey] = this.camelizeObj(obj[key])
        }
      }
      return newObj
    }
    // 如果是基础类型（如字符串、数字、布尔值），直接返回
    return obj
  }

  /**
   * 将对象的键从驼峰命名转换为下划线命名。
   * 如果对象的值是嵌套的对象，也会递归转换。
   *
   * @param obj - 输入的对象
   * @returns 返回转换后的对象
   */
  underlineObj(obj: Record<string, any>): Record<string, any> {
    if (Array.isArray(obj)) {
      // 如果是数组，递归转换数组中的每一项
      return obj.map((item) => this.underlineObj(item))
    } else if (obj !== null && typeof obj === 'object') {
      // 如果是对象，转换对象的每个键
      const newObj: Record<string, any> = {}
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          // 转换当前键，并递归转换值
          const newKey = this.camelizeToUnderLine(key)
          newObj[newKey] = this.underlineObj(obj[key])
        }
      }
      return newObj
    }
    // 如果是基础类型（如字符串、数字、布尔值），直接返回
    return obj
  }

  underLineToCamelize(key: string) {
    return key.replace(/\_(\w)/g, (_, letter) => {
      return letter.toUpperCase()
    })
  }

  camelizeToUnderLine(key: string) {
    return key.replace(/([A-Z])/g, '_$1').toLowerCase()
  }

  ossVideoToPng(ossUrl: string) {
    return `${ossUrl}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast`
  }

  emailFormatValidator(email: string) {
    const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    return reg.test(email)
  }

  getMobileBrowserType() {
    if (typeof window === 'undefined' || !window.navigator) {
      return 'unknown'
    }
    const ua = window.navigator.userAgent.toLowerCase()
    // The order of checks is important because some user agent strings contain multiple keywords.
    // We check for more specific browsers first.
    if (ua.includes('micromessenger')) {
      return 'wechat' // 微信内置浏览器
    }
    if (ua.includes('qqbrowser') || ua.includes('qq/')) {
      return 'qq' // QQ浏览器
    }
    if (ua.includes('ucbrowser')) {
      return 'uc' // UC浏览器
    }
    if (ua.includes('samsungbrowser')) {
      return 'samsung' // 三星浏览器
    }
    if (ua.includes('crios')) {
      return 'chrome' // Chrome on iOS
    }
    if (ua.includes('fxios')) {
      return 'firefox' // Firefox on iOS
    }
    if (ua.includes('chrome')) {
      return 'chrome' // Chrome
    }
    if (ua.includes('firefox')) {
      return 'firefox' // Firefox
    }
    if (ua.includes('safari')) {
      return 'safari' // Safari
    }
    return 'unknown'
  }

  getMobilePlatformType() {
    if (typeof window === 'undefined' || !window.navigator) {
      return 'unknown'
    }
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
      return 'ios'
    }
    if (ua.includes('android')) {
      return 'android'
    }
    if (ua.includes('windows phone')) {
      return 'windows_phone'
    }

    return 'unknown'
  }

  transferCountryKeyToZhTranslateText(key: string) {
    const targetMarket = (ZH_TRANSLATION as any).dashboard.projectCreatePage.targetMarketSelect
    const value = targetMarket[key]
    return value || key
  }

  transferProvinceKeyToZhTranslateText(key: string) {
    const province = (ZH_TRANSLATION as any).i18n.province
    const value = province[key]
    return value || key
  }


  downloadFile(url: string, name: string) {
    return fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const link = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = link
        a.download = name
        a.click()
      })

  }

}


export const commonUtils = new CommonUtils()
